import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import DoneIcon from '@mui/icons-material/Done';
import WarningIcon from '@mui/icons-material/Warning';
import { useEffect, useState } from 'react';
import { t } from '../i18n';

export async function callApi(method, url, token, body, contentType, defaultHeaders) {

    let headers = defaultHeaders ? defaultHeaders : {};
    if (token) Object.assign(headers, { 'Authorization': `Bearer ${token}` });
    const sessionToken = sessionStorage.getItem("sessionToken");
    if (sessionToken) {
        let sessiontokenObj = sessionToken ? JSON.parse(sessionToken) : null;


        if (sessiontokenObj && typeof sessiontokenObj === 'object') {
            if (('CustomStyle' in sessiontokenObj)) {
                sessiontokenObj.CustomStyle = '';
            }
        }
        Object.assign(headers, { 'sessionToken': JSON.stringify(sessiontokenObj) });
    }

    if (contentType) Object.assign(headers, { "Content-Type": contentType });
    else Object.assign(headers, { "Content-Type": "application/json" });

    let options = {
        method: method,
        headers: headers,
        body: (!body || (contentType && contentType !== "application/json")) ? body : JSON.stringify(body),
        cache: "no-store"
    };
    try {
        let response = await fetch(url, options);
        if (!response.ok) {
            let body = await response.text();
            if (body) {
                throw new Error(body);
            } else {
                throw new Error(`Server returned status:${response.status} ${response.statusText}, Details:${body}, Type: ${response.type}.`);
            }
        }
        if (contentType === "text/html; charset=UTF-8") response = await response.text();
        else if (contentType === "text/javascript") response = await response.text();
        else response = await response.json();
        if (response && response.errors && response.errors.length) {
            throw new Error(`Error: ${response.errors[0].message}`);
        }
        return response;
    } catch (err) {
        throw new Error(err.message);
    }
}

function schemaToGql(schema, fullTableName) {
    let strGql = schema.columns
        .filter(col => col.fullTableName === fullTableName)
        .map((col, i) => col.columnName).join(' ');

    schema.tables.filter(t => t.parentTable === fullTableName).forEach(t => {
        strGql += " " + t.tableName + schemaToGql(schema, t.fullTableName);
    });

    return '{' + strGql + '}';
}

function analyzeSchema(colNames) {
    let columns = colNames.map((col, i) => {
        let parts = col.split(".");
        let fullTableName = (parts.length === 1) ? " " : parts.filter((p, i) => i < parts.length - 1).join('.');
        let columnName = parts[parts.length - 1];
        return {
            fullTableName,
            columnName
        };
    });

    let tables = [];
    columns.forEach((col, i) => {
        if (tables.findIndex(table => table.fullTableName === col.fullTableName) !== -1) return;
        let parts = col.fullTableName.split('.');
        let tableName = parts[parts.length - 1];
        let parentTable = ' ';
        if (tableName === ' ') parentTable = null;
        if (parts.length > 1) parentTable = parts[parts.length - 2];
        tables.push({
            fullTableName: col.fullTableName,
            tableName,
            parentTable
        });
    });

    return {
        columns,
        tables
    };
}
export function gridColumnsToGql(columns, additionalColumns) {
    let gqlStr = "";
    let colNames = columns.filter(col => col.controlType !== "List").map(col => col.columnName);
    if (additionalColumns) colNames = [...colNames, ...additionalColumns.filter(a => !colNames.includes(a))];
    let schema = analyzeSchema(colNames);
    gqlStr += schemaToGql(schema, ' ');
    return gqlStr;
}

export function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
}

export function createGql(queryObject, columns, additionalColumns, prms, prmValues, defaultVariables) {
    let prmStr = "";
    let gqlVars = { ...defaultVariables };
    if (prms && prms.length) {
        prmStr = prms.map((prm) => {
            validateParameter(prm, prmValues);
            return prm.parameterName + ":$" + prm.parameterName;
        }).join(',');
        prmStr = `(${prmStr})`;
        prms.forEach((prm) => {
            if (prmValues[prm.parameterName]) {
                let val = prmValues[prm.parameterName];
                if (prm.type === "Date" && isDateValid(prmValues[prm.parameterName])) {
                    val = stringToDate(val);
                }
                gqlVars[prm.parameterName] = val;
            }
        });

    }
    let gqlStr = ""
    if (queryObject) gqlStr = `{${queryObject}${prmStr}`;

    let colNames = columns.filter(col => col.controlType !== "List").map(col => col.columnName);
    if (additionalColumns) colNames = [...colNames, ...additionalColumns.filter(a => !colNames.includes(a))];

    let schema = analyzeSchema(colNames.filter(onlyUnique));
    gqlStr += schemaToGql(schema, ' ');

    if (queryObject) gqlStr += "}";

    return {
        query: gqlStr,
        variables: gqlVars
    };
}

export function createGqlX(queryObject, columns, additionalColumns, prms, prmValues) {
    let prmStr = "";
    let gqlVars = {};
    if (prms && prms.length) {
        prmStr = prms.map((prm) => {
            validateParameter(prm, prmValues);
            return prm.parameterName + ":$" + prm.parameterName;
        }).join(',');
        prmStr = `(${prmStr})`;
        prms.forEach((prm) => {
            if (prmValues[prm.parameterName]) {
                let val = prmValues[prm.parameterName];
                if (prm.type === "Date" && isDateValid(prmValues[prm.parameterName])) {
                    val = stringToDate(val);
                }
                gqlVars[prm.parameterName] = val;
            }
        });

    }
    let gqlStr = `{${queryObject}${prmStr}{`;

    let colsByObj = {};
    columns.forEach((col, i) => {
        if (!col.columnName) return;
        let columnName = col.columnName;
        let objectName = "";
        let idxOfPoint = columnName.indexOf('.');
        if (idxOfPoint > 0 && idxOfPoint < columnName.length) {
            objectName = columnName.substring(0, idxOfPoint);
            columnName = columnName.substring(idxOfPoint + 1);
        }
        if (!colsByObj[objectName]) colsByObj[objectName] = [];
        colsByObj[objectName].push({ objectName: objectName, columnName: columnName });
    });

    if (additionalColumns) {
        additionalColumns.forEach((colName, i) => {
            if (!colsByObj[""]) {
                colsByObj[""] = [{ columnName: colName }];
            } else {
                if (!colsByObj[""].find(c => c.columnName === colName)) {
                    colsByObj[""].push({ columnName: colName });
                }
            }
        });
    }

    gqlStr += Object.keys(colsByObj).map((objectName, i) => {
        return ((objectName) ? objectName + "{" : "") +
            colsByObj[objectName].map((col) => {
                return col.columnName
            }).join(' ') +
            ((objectName) ? "}" : "");
    }).join(' ');

    gqlStr += "}}";

    return {
        query: gqlStr,
        variables: gqlVars
    };
}

export function createPkPrms(layout) {
    if (!layout || !layout.primaryKey) return null;
    return layout.primaryKey.map(pkCol => ({ parameterName: pkCol }));
}

export function createPkVals(layout, data, editRowIndex) {
    if (!layout || !layout.primaryKey || !data || editRowIndex < 0) return null;
    let pkVals = {};
    if (!layout.primaryKey) return pkVals;
    layout.primaryKey.forEach(pkCol => {
        pkVals[pkCol] = getPropValue(data[editRowIndex], pkCol)
    });
    return pkVals;
}

export function getPropValue(obj, propPath) {
    if (!propPath) return undefined;
    let pathArray = propPath.split('.');

    return pathArray.reduce((o, key) => {
        return (o && o[key]) ? o[key] : ""
    }, obj);
}

export function setPropValue(obj, propPath, value) {
    if (!obj) return;
    let pathArray = propPath.split('.');
    let o = obj;
    pathArray.forEach((propertyName, i) => {
        //if (!o) return;
        if (i === pathArray.length - 1) o[propertyName] = value;
        else {
            if (!o[propertyName]) o[propertyName] = {};
            o = o[propertyName];

        };
    });
}

export function isDateValid(strDate) {
    let date = stringToDate(strDate);
    if (date === "Invalid Date" || isNaN(date) || !date) {
        return false;
    }
    return true;
}

export function strDateToUriString(strDate) {
    let d = stringToDate(strDate);
    return d.toUTCString();
}

export function stringToDate(str) {
    if (!str) return null;
    let parts = str.split('/');
    if (parts.length !== 3) return null;
    try {
        let yearParts = parts[2].split(' ');
        if (yearParts.length === 1) {
            return (new Date(parts[2], parts[1] - 1, parts[0]));
        } else if (yearParts.length !== 2) {
            return null;
        }
        let year = yearParts[0];
        let timeParts = yearParts[1].split(':');
        if (timeParts.length !== 2) return null;
        return (new Date(year, parts[1] - 1, parts[0], timeParts[0], timeParts[1]));
    } catch {
        return null;
    }
}

export function dateToIsoString(d) {
    return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
}

export function dateToTimeString(d) {
    return d.getHours().toString().padStart(2, '0') + ":" + d.getMinutes().toString().padStart(2, '0');
}

export function validateParameter(prm, prmValues) {
    if (prm.type === "Date" &&
        prmValues[prm.parameterName]
        && !isDateValid(prmValues[prm.parameterName])
    ) {
        throw new Error(`${prmValues[prm.parameterName]} is not a valid date`);
    }
}

export function capitalize(s) {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
}


export function ErrorAlert(props) {
    const { message, setMessage, language } = props;
    const [isExiting, setIsExiting] = useState(false);
    const [displayMessage, setDisplayMessage] = useState(message);

    const handleClose = () => {
        setIsExiting(true);
        setTimeout(() => {
            setMessage(null);
        }, 300);
    };

    useEffect(() => {
        if (message) {
            setDisplayMessage(message);
            setIsExiting(false);
        } else if (displayMessage && !message) {
            setIsExiting(true);
            setTimeout(() => {
                setDisplayMessage(null);
            }, 300);
        }
    }, [message, displayMessage]);

    if (!displayMessage) return null;

    return (
        <div className="position-fixed top-0 start-50 translate-middle-x mt-3" style={{ zIndex: 9999 }}>
            <div className={`custom-alert custom-alert-error ${isExiting ? 'alert-slide-out' : ''}`}>
                <div className="custom-alert-icon custom-alert-icon-error">
                    <PriorityHighIcon />
                </div>
                <div className="custom-alert-content">
                    <div className="custom-alert-title">{t('common.error', language)}</div>
                    <div className="custom-alert-message custom-alert-scrollable">{displayMessage}</div>
                </div>
                <button className="custom-alert-close" onClick={handleClose}>
                    <i className="bi bi-x"></i>
                </button>
            </div>
        </div>

    );
}
export function SuccessAlert(props) {
    const { message, setMessage, language } = props;
    const [isExiting, setIsExiting] = useState(false);
    const [displayMessage, setDisplayMessage] = useState(message);

    const handleClose = () => {
        setIsExiting(true);
        setTimeout(() => {
            setMessage(null);
        }, 300);
    };

    useEffect(() => {
        if (message) {
            setDisplayMessage(message);
            setIsExiting(false);
        } else if (displayMessage && !message) {
            setIsExiting(true);
            setTimeout(() => {
                setDisplayMessage(null);
            }, 300);
        }
    }, [message, displayMessage]);

    if (!displayMessage) return null;

    return (
        <div className="position-fixed top-0 start-50 translate-middle-x mt-3" style={{ zIndex: 9999 }}>
            <div className={`custom-alert custom-alert-success ${isExiting ? 'alert-slide-out' : ''}`}>
                <div className="custom-alert-icon custom-alert-icon-success">
                    <DoneIcon />
                </div>
                <div className="custom-alert-content">
                    <div className="custom-alert-title">{t('common.success', language)}</div>
                    <div className="custom-alert-message custom-alert-scrollable">{displayMessage}</div>
                </div>
                <button className="custom-alert-close" onClick={handleClose}>
                    <i className="bi bi-x"></i>
                </button>
            </div>
        </div>
    );
}

export function WarningAlert(props) {
    const { message, setMessage, language } = props;
    const [isExiting, setIsExiting] = useState(false);
    const [displayMessage, setDisplayMessage] = useState(message);

    const handleClose = () => {
        setIsExiting(true);
        setTimeout(() => {
            setMessage(null);
        }, 300);
    };

    useEffect(() => {
        if (message) {
            setDisplayMessage(message);
            setIsExiting(false);
        } else if (displayMessage && !message) {
            setIsExiting(true);
            setTimeout(() => {
                setDisplayMessage(null);
            }, 300);
        }
    }, [message, displayMessage]);

    if (!displayMessage) return null;

    return (
        <div className="position-fixed top-0 start-50 translate-middle-x mt-3" style={{ zIndex: 9999 }}>
            <div className={`custom-alert custom-alert-warning ${isExiting ? 'alert-slide-out' : ''}`}>
                <div className="custom-alert-icon custom-alert-icon-warning">
                    <WarningIcon />
                </div>
                <div className="custom-alert-content">
                    <div className="custom-alert-title">{t('common.warning', language)}</div>
                    <div className="custom-alert-message custom-alert-scrollable">{displayMessage}</div>
                </div>
                <button className="custom-alert-close" onClick={handleClose}>
                    <i className="bi bi-x"></i>
                </button>
            </div>
        </div>
    );
}


export function mergeObjects(obj1, obj2) {
    let merged = {};
    for (let key in obj1) {
        if (typeof obj2[key] !== 'undefined') {
            if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
                merged[key] = mergeObjects(obj1[key], obj2[key]);
            } else {
                merged[key] = obj2[key];
            }
        } else {
            merged[key] = obj1[key];
        }
    }
    for (let key in obj2) {
        if (typeof obj1[key] === 'undefined') {
            merged[key] = obj2[key];
        }
    }
    return merged;
}



export function objectsAreEqual(obj1, obj2) {
    try {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (let key of keys1) {
            if (typeof obj1[key] === 'object' && obj1[key] !== null &&
                typeof obj2[key] === 'object' && obj2[key] !== null) {
                if (!objectsAreEqual(obj1[key], obj2[key])) { return false; }
                continue;
            } else if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    } catch (err) {
        return false;
    }
}

export function urlStringToPk(urlParams) {
    const pkDefs = [];
    const pkVals = {};
    if (!urlParams) return [pkDefs, pkVals];
    if (urlParams.substring(0, 1) === '?') urlParams = urlParams.substring(1);
    const urlPrms = urlParams.split('&');
    for (let i = 0; i < urlPrms.length; i++) {
        const urlPrmParts = urlPrms[i].split('=');
        if (urlPrmParts[0].toString().toUpperCase() === "INSTANCENAME") continue;
        pkDefs.push({ "parameterName": urlPrmParts[0] });
        if (urlPrmParts.length === 2) {
            pkVals[urlPrmParts[0]] = urlPrmParts[1];
        }
    }
    return { defs: pkDefs, vals: pkVals };
}

export function urlStringToObj(urlParams) {
    const obj = {};
    if (!urlParams) return [obj];
    if (urlParams.substring(0, 1) === '?') urlParams = urlParams.substring(1);
    const urlPrms = urlParams.split('&');
    for (let i = 0; i < urlPrms.length; i++) {
        const urlPrmParts = urlPrms[i].split('=');
        if (urlPrmParts[0].toString().toUpperCase() === "INSTANCENAME") continue;
        if (urlPrmParts.length === 2) {
            obj[urlPrmParts[0]] = urlPrmParts[1];
        }
    }
    return obj;
}

export function getAllFormColumns(formLayout, editModeColumnNames) {
    const formCols = formLayout.tabs.map(tab => tab.columns).reduce((prev, current) => prev ? prev.concat(current) : current);
    const formColNames = formCols.filter(col => col.controlType !== "List").map(col => col.columnName);
    editModeColumnNames = [...editModeColumnNames, ...formColNames.filter(a => !editModeColumnNames.includes(a))];
    const formSecColNames = formCols.filter(col => col.secondaryField).map(col => col.secondaryField);
    editModeColumnNames = [...editModeColumnNames, ...formSecColNames.filter(a => !editModeColumnNames.includes(a))];
    editModeColumnNames = [...editModeColumnNames, ...formLayout.primaryKey.filter(a => !editModeColumnNames.includes(a))];
    editModeColumnNames = [...editModeColumnNames, ...formLayout.additionalColumns.filter(a => !editModeColumnNames.includes(a))];
    return editModeColumnNames;
}

export const addParamTolookUpQuery = (queryStr) => {
    const pattern = /\{([^}]*)\{([^}\s]+)\s+([^}\s]+)\s+([^}]*)\}\}/;
    const match = pattern.exec(queryStr);

    if (match) {
        const tableName = match[1];
        const pkField = match[2];
        const lookUpField = match[3];
        const secondaryField = match[4];
        const qryStr = `{` + tableName + '(' + lookUpField + ':$' + lookUpField + ',' + secondaryField + ':$' + secondaryField + '){' +
            pkField + ' ' + lookUpField + ' ' + secondaryField + '}}'
        return {
            queryStr: qryStr,
            tableName: tableName,
            pkField: pkField,
            lookUpField: lookUpField,
            secondaryField: secondaryField
        };
    }
    return queryStr;
}
export const filterByRole = (menu, role) => {
    const result = [];
    for (const item of menu) {
        // Αν το item είναι explicitly μη ορατό, το παραλείπουμε
        if (item.nonVisible === "true") {
            continue;
        }
        const itemRoles = item.Rools ? item.Rools.split(",") : [];
        const hasRole = itemRoles.includes(role);
        let newItem = { ...item };
        // Αν έχει υπομενού, κάνω αναδρομή
        if (item.options) {
            newItem.options = filterByRole(item.options, role);
        }
        // Βάζω το item μόνο αν:έχει τον ρόλο ή έχει υπομενού με αποτελέσματα
        if (hasRole || (newItem.options && newItem.options.length > 0)) {
            result.push(newItem);
        }
    }
    return result;
};

export const filterAllByRole = (menu, role) => {
    const result = [];
    for (const item of menu) {
        if (item.nonVisible === "true") { continue; }
        const itemRoles = item.Rools ? item.Rools.split(",") : [];
        const hasRole = !itemRoles || itemRoles.includes(role);
        let newItem = { ...item };
        // Αν έχει υπομενού, κάνω αναδρομή
        //  if (item.options) {
        //      newItem.options = filterByRole(item.options, role);
        //  }
        if (item.options) {
            const filteredOptions = filterByRole(item.options, role);
            if (filteredOptions.length > 0) {
                newItem.options = filteredOptions;
            } else {
                delete newItem.options; // Καθαρίζουμε τα άδεια options
            }
        }
        // Βάζω το item μόνο αν:έχει τον ρόλο ή έχει υπομενού με αποτελέσματα ή δεν υπάρχουν Rools 
        //  if (hasRole || (newItem.options && newItem.options.length > 0)) {
        //      result.push(newItem);
        //  }
        if (hasRole || newItem.options) {
            result.push(newItem);
        }
    }
    return result;
};

export const getPathsWithRoles = (menu, role) => {
    if (!menu || !Array.isArray(menu) || menu.length === 0) {
        return [];
    }
    const linksSet = new Set();
    const linkPath = (items) => {
        linksSet.add("/");
        for (const item of items) {
            if (item.nonVisible === "true") {
                //const itemRoles = item.Rools ? item.Rools.split(",") : null;
                const hasAccess = item.Rools ? false : true;
                if (item.link && hasAccess) {
                    linksSet.add(item.link);
                }
            }
            if (!item.nonVisible || item.nonVisible === "false") {
                const itemRoles = item.Rools ? item.Rools.split(",") : null;
                const hasAccess = !itemRoles || itemRoles.includes(role);
                if (item.link && hasAccess) {
                    linksSet.add(item.link);
                }
            }
            if (item.options) {
                linkPath(item.options);
            }
        }
    };
    linkPath(menu);
    return Array.from(linksSet);
};



export const getCultureInfo = (language) => {
    if (language === 'el' || language === 'el-GR') {
        return 'el';
    }
    else if (language === 'en' || language === 'en-US') {
        return 'en';
    }
    else {
        return 'el';
    }
}

export function getIsoMonthStartOf(currentDate) {
    if ((currentDate instanceof Date) && !isNaN(currentDate)) {
        return new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    }
    return currentDate;
}
export function getIsoMonthEndOf(currentDate) {
    return currentDate;
}

export function getIsoWeekStartOf(currentDate) {
    const day = currentDate.getDay();
    const diff = (day === 0 ? -6 : 1 - day);
    const startOfWeek = new Date(currentDate);
    startOfWeek.setDate(startOfWeek.getDate() + diff);
    startOfWeek.setHours(0, 0, 0, 0);
    return startOfWeek;
}

export function getisoWeekEndOf(currentDate) {
    const endOfWeek = getIsoWeekStartOf(currentDate);
    endOfWeek.setDate(endOfWeek.getDate() + 7);
    endOfWeek.setHours(0, 0, 0, 0);
    return endOfWeek;
}

export function getisoStartDate(currentDate) {
    const startDate = new Date(currentDate);
    startDate.setDate(startDate.getDate());
    startDate.setHours(0, 0, 0, 0);
    return startDate;
}
export function getisoEndDate(currentDate) {
    const endDate = new Date(currentDate);
    endDate.setDate(endDate.getDate() + 1);
    endDate.setHours(0, 0, 0, 0);
    return endDate;
}

export function getisoWeekDays(language) {
    const formatter = new Intl.DateTimeFormat(language, { weekday: 'long' });
    const weekDays = [];
    for (let i = 0; i < 7; i++) {
        // Ξεκινάμε από Κυριακή (1970-01-04 ήταν Κυριακή)
        const date = new Date(1970, 0, 5 + i);
        weekDays.push(formatter.format(date));
    }
    return weekDays;
}
export function Round(value, decimals) {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

export function isTodayOrFutureDate(currentDate) {
    const today = new Date();
    if (currentDate.getFullYear() !== today.getFullYear()) return false;
    if (currentDate.getMonth() < today.getMonth()) return false;
    if (currentDate.getMonth() === today.getMonth() &&
        currentDate.getDate() < today.getDate()) return false;
    return true;
}

export const defaultRootColors = {
    '--color-main-background': '#B6265F',
    '--color-secondary-background': '#e3a8c0',
    '--color-secondary-dark-background': '#64394a',
    '--color-shadow-background': '#B6265F40',
    '--color-capacity-background': '#fae6ee',
    '--color-capacity-full-background': '#e6b5c8dc'
};




